import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import { forwardRef } from 'react';
import hljs from 'highlight.js';
import 'highlight.js/styles/vs2015.css';
import * as views from './Highlighter.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// https://highlightjs.readthedocs.io/en/latest/supported-languages.html
var supportedLanguages = new Map([["javascript", "javascript"], ["js", "javascript"], ["xml", "xml"], ["mathml", "xml"], ["html", "html"], ["css", "css"], ["clike", "c"], ["svg", "svg"]]);
var unsupportedIndentationLanguages = ["makefile", "shell", "bash"];

var indentCode = function indentCode(content) {
  var spaceCount = 0;
  var space = 2;
  var openTagRegex = "(\\{|<[A-Za-z ]|<\\/[A-Za-z ]|\\[|\\()";
  var closeTagRegex = "(\\}|<\\/|[A-Za-z ]>|\\/>|\\]|\\))";
  var openCloseRegex = "^<.*\\/>$";
  var indentedContent = content.replace(/\t/g, "").split(/\r?\n/).map(function (line) {
    var _indentedLine$match, _indentedLine$match2, _indentedLine$match3;

    var indentedLine = line.trim();
    var openCount = _toConsumableArray(indentedLine.matchAll(new RegExp(openTagRegex, "g"))).length || 0;
    var closeCount = _toConsumableArray(indentedLine.matchAll(new RegExp(closeTagRegex, "g"))).length || 0;
    var openCloseCount = ((_indentedLine$match = indentedLine.match(openCloseRegex)) === null || _indentedLine$match === void 0 ? void 0 : _indentedLine$match.length) || 0;
    var isClosingFirst = openCount === closeCount && (((_indentedLine$match2 = indentedLine.match(closeTagRegex)) === null || _indentedLine$match2 === void 0 ? void 0 : _indentedLine$match2.index) || 0) < (((_indentedLine$match3 = indentedLine.match(openTagRegex)) === null || _indentedLine$match3 === void 0 ? void 0 : _indentedLine$match3.index) || 0);
    if (closeCount > openCount || isClosingFirst) spaceCount -= space;
    if (openCloseCount > 0) spaceCount += space;
    indentedLine = " ".repeat(spaceCount < 0 ? 0 : spaceCount) + indentedLine;
    if (openCloseCount > 0) spaceCount -= space;
    if (closeCount < openCount || isClosingFirst) spaceCount += space;
    return indentedLine;
  }).join("\n");
  return indentedContent;
};

export var Highlighter = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var content = _ref.content,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? "javascript" : _ref$language;
  var supportedLanguage = supportedLanguages.get(language);
  var highlighted = supportedLanguage ? hljs.highlight(indentCode(content), {
    language: supportedLanguage,
    ignoreIllegals: true
  }) : hljs.highlightAuto(content, unsupportedIndentationLanguages);
  return _jsx(views.Wrapper, {
    ref: ref,
    className: "hljs",
    children: _jsx(views.CodeWrapper, {
      tabIndex: 0,
      children: _jsx(views.Code, {
        role: "code",
        dangerouslySetInnerHTML: {
          __html: highlighted.value
        }
      })
    })
  });
});